import { sortSizeAware } from '../../../shared/lib/sortSizeOptions';

// Запасні людські назви для значень-кодів (слагів), якщо в пресеті немає
// лейбла (напр. вісь прийшла лише з оффера). Щоб у селекті ніде не світився
// технічний ключ типу "ekoshkira".
const KNOWN_SLUG_LABELS = {
    // матеріал
    ekoshkira: 'Екошкіра',
    leather: 'Натуральна шкіра',
    satin: 'Сатин',
    microfiber: 'Мікрофібра',
    'premium-suede': 'Замша',
    zamsh: 'Замш',
    'eko-zamsh': 'Еко-замш',
    lak: 'Лак',
    'shchilnyi-material': 'Щільний матеріал',
    // форма/тип підборів
    straight: 'Прямий',
    flare: 'Чарка',
    triangle: 'Трикутник',
};

const isSlugLike = (value) => /^[a-z0-9][a-z0-9-]*$/.test(String(value ?? ''));

export const getAxisPresetLabel = (preset) => {
    if (preset && typeof preset === 'object') {
        const value = typeof preset.value !== 'undefined' ? String(preset.value) : '';
        const labelUa = typeof preset.label === 'string' ? preset.label : preset.label?.ua;
        const labelEn = preset.label?.en;
        const label = labelUa || labelEn;
        // Якщо лейбл є і він не дублює технічний ключ — використовуємо його.
        if (label && label !== value) return label;
        // Інакше пробуємо словник відомих слагів, далі — сам лейбл/value.
        if (value && KNOWN_SLUG_LABELS[value]) return KNOWN_SLUG_LABELS[value];
        if (label) return label;
        if (value) return isSlugLike(value) && KNOWN_SLUG_LABELS[value] ? KNOWN_SLUG_LABELS[value] : value;
    }
    if (KNOWN_SLUG_LABELS[String(preset ?? '')]) return KNOWN_SLUG_LABELS[String(preset)];
    return String(preset ?? '');
};

export const getAxisPresetValue = (preset) => {
    if (preset && typeof preset === 'object' && typeof preset.value !== 'undefined') {
        return String(preset.value);
    }
    return String(preset ?? '');
};

// Сортує опції осі: спочатку числові розміри (за зростанням), далі буквені
// (XS→S→M→L→XL…, разом з комбінованими S/M, L/XL), решта нечислових значень
// (кольори, матеріали) зберігають вихідний порядок. Логіка — у shared/lib,
// щоб той самий порядок діяв і в шаблонах категорії, і при заповненні товару.
export const sortAxisOptionsAsc = (options = []) =>
    sortSizeAware(options, {
        getValue: getAxisPresetValue,
        getLabel: getAxisPresetLabel,
    });